import React from "react";
import { useLoaderData } from "react-router";

import classNames from "classnames";
import { Container } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";

import BookingModal from "./components/BookingModal";
import Filters from "./components/Filters";
import GamesTable from "./components/GamesTable";
import { BookingModalProvider } from "./contexts/BookingModal";
import { FiltersProvider } from "./contexts/Filters";
import { OpenGamesProvider, useOpenGamesContext } from "./contexts/OpenGames";

import { store } from "../..";
import "../../assets/css/umphub/pages/opengames.scss";
import Pagination from "../../components/Pagination";
import SelectItemsPerPage from "../../components/SelectItemsPerPage";
import UmpireInfoModal from "../../components/UmpireInfoModal";
import { PaginationProvider } from "../../contexts/Pagination";
import { UmpireInfoModalProvider } from "../../contexts/UmpireInfoModal";
import {
    globalActions,
    selectSetting,
    selectSite,
} from "../../features/global/globalSlice";
import { useAppSelector } from "../../hooks/reduxHooks";
import { getGamesBySite } from "../../lib/api";
import { IGame } from "../../types/api";
import { UmpirePay } from "../../types/shared";

export const loader = async ({ site }: any) => {
    const { settings, sites } = store.getState().global;
    const promises = [];
    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !sites.length && promises.push(store.dispatch(globalActions.getSites()));

    const [{ games }] = await Promise.all([getGamesBySite(site), promises]);

    return {
        site,
        games,
    };
};

const OpenGames = (): React.JSX.Element => {
    const { site: siteId, games } = useLoaderData() as {
        site: number;
        games: IGame[];
    };

    const site = useAppSelector(state => selectSite(state, siteId));
    const umpirePay = useAppSelector(state =>
        selectSetting(state, `${site?.settingPrefix}umpire_pay`),
    )?.setting as UmpirePay[];

    return (
        <Container
            className={classNames("py-5", "openGames")}
            data-testid="openGamesContent"
        >
            {siteId !== 1 && (
                <h5 className={classNames("text-danger", "mb-4")}>
                    Please Note: Field Assignment and Age Level may change
                    depending on tournament schedule adjustments.
                </h5>
            )}
            <FiltersProvider initialGames={games}>
                <Filters />

                <PaginationProvider>
                    <SelectItemsPerPage />
                    <OpenGamesProvider
                        initialGames={games}
                        umpirePay={umpirePay}
                        site={siteId}
                    >
                        <UmpireInfoModalProvider>
                            <BookingModalProvider>
                                <GamesTable />
                                <UmpireInfoModal />
                                <BookingModal />
                            </BookingModalProvider>
                        </UmpireInfoModalProvider>
                        <Pagination useContext={useOpenGamesContext} />
                    </OpenGamesProvider>
                </PaginationProvider>
            </FiltersProvider>
        </Container>
    );
};

export default OpenGames;
